
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetooutstationinnovacrysta() {



    const cardData =
    {
        keyword: 'Pune to Outstation Innova Crysta Booking',
        heading: 'Meghana Cab : Pune to Outstation Innova Crysta Booking',
        headingDescription: 'Meghana Cab offers Pune to Outstation Innova Crysta Booking, delivering a luxurious, safe, and spacious travel experience for long-distance journeys across Maharashtra and beyond. Whether you are heading for a spiritual trip to Shirdi, a relaxing escape to Mahabaleshwar, a beach holiday in Goa, or a business meeting in Hyderabad, our Innova Crysta fleet ensures unmatched comfort and convenience.',


        top: 'Top Places to Visit in Pune Outstation with Meghana Cab',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Just 120 km from Pune, Mahabaleshwar is a lush hill station nestled in the Western Ghats. Famous for its cool climate, strawberry farms, and viewpoints like Arthur’s Seat and Wilson Point, it offers boating at Venna Lake, treks to Lingmala Waterfall, and spiritual sites like the Panchganga Temple. A top pick for families, honeymooners, and nature lovers, especially during winter and monsoon."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Only 65–70 km from Pune, these twin hill stations are perfect for a weekend escape. Surrounded by Sahyadri valleys and monsoon-fed waterfalls, attractions include Bhushi Dam, Tiger’s Leap, Karla Caves, and Rajmachi Fort. Ideal for trekking, picnics, and romantic getaways, Lonavala also offers resorts, adventure parks, and the iconic Lonavala chikki."
  },
  {
    "title": "Lavasa",
    "description": "Around 60 km from Pune, Lavasa is a planned hill city built on the banks of Warasgaon Lake. Inspired by Italian architecture, it offers lakeside promenades, cycling trails, water sports, and scenic cafes. Ideal for couples, families, and photographers, Lavasa provides a tranquil escape into nature with modern amenities and European-style charm."
  },
  {
    "title": "Alibaug",
    "description": "Located 145 km from Pune, Alibaug is a serene coastal town known for its clean beaches like Nagaon and Kashid, and historical sea forts such as Kolaba Fort. Enjoy seafood, parasailing, and heritage walks. Ideal for beach lovers and groups, Alibaug is a favorite for one-day or weekend road trips from Pune, especially in winter."
  },
  {
    "title": "Shirdi",
    "description": "Situated about 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Shri Sai Baba. The Shri Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi are major spiritual spots. Well-organized with prasadalaya, accommodations, and crowd management, Shirdi is ideal for spiritual seekers and family pilgrimages on one or two-day cab packages."
  },
  {
    "title": "Nashik",
    "description": "Roughly 210 km from Pune, Nashik is known for its religious sites like Trimbakeshwar and the Kumbh Mela, as well as its wine culture. Sula Vineyards, York Winery, and Soma Vine Village offer wine tours and tastings. The city blends spirituality, culture, and leisure — ideal for both pilgrims and weekend tourists seeking scenic vineyard experiences."
  },
  {
    "title": "Bhimashankar",
    "description": "At a distance of 110 km from Pune, Bhimashankar is home to one of the 12 Jyotirlingas of Lord Shiva. Surrounded by dense forests of the Western Ghats, it offers a peaceful temple experience as well as nature trails inside the Bhimashankar Wildlife Sanctuary. A perfect destination for devotees, wildlife enthusiasts, and monsoon trekkers."
  },
  {
    "title": "Kolhapur",
    "description": "Located around 235 km from Pune, Kolhapur is famous for the Mahalaxmi Temple, spicy cuisine, Kolhapuri chappals, and Maratha-era forts. Attractions include Rankala Lake, Panhala Fort, and the New Palace Museum. It’s a vibrant mix of history, spirituality, and traditional crafts, ideal for a 2-day heritage and food-focused trip from Pune."
  },
  {
    "title": "Goa",
    "description": "Approximately 450 km from Pune, Goa is the ultimate beach escape. Whether it’s the nightlife of Baga and Anjuna, the calm of Palolem, or heritage churches of Old Goa, this destination suits party-goers, families, and honeymooners. Known for its seafood, flea markets, water sports, and Portuguese charm, Goa is perfect for long weekends and extended vacations."
  },
  {
    "title": "Aurangabad (Ajanta & Ellora Caves)",
    "description": "About 250–270 km from Pune, Aurangabad is the gateway to two UNESCO World Heritage Sites—Ajanta and Ellora Caves. The stunning rock-cut Buddhist murals at Ajanta and the massive Kailasa Temple at Ellora showcase ancient Indian art. Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga complete a culture-packed itinerary ideal for a 2-day trip."
  }
],

  "services": [
    {
      "name": "Pune to Outstation Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to your favorite outstation destination with ease. Our service offers comfort, reliability, and ample luggage space—ideal for family vacations, weekend getaways, or corporate tours across Maharashtra and beyond."
    },
    {
      "name": "Rent Innova Crysta for Outstation Pune",
      "description": "Rent a well-maintained Innova Crysta in Pune for your outstation travel needs. Whether you're heading to a hill station, heritage city, or coastal town, our rentals ensure a smooth and luxurious experience with top-tier comfort and convenience."
    },
    {
      "name": "One Way Innova Crysta Pune Outstation",
      "description": "Planning a one-way trip from Pune? Our Innova Crysta one-way cab service is the perfect solution—pay only for one side and travel in comfort. Ideal for drop-offs, relocations, or single-leg journeys to nearby cities and towns."
    },
    {
      "name": "Round Trip Innova Crysta Outstation Pune",
      "description": "Choose our round-trip Innova Crysta service for your Pune to outstation travel. Enjoy door-to-door service, a professional chauffeur, and the flexibility to explore and return at your convenience, all in a premium, spacious SUV."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Outstation Pune",
      "description": "Sit back and relax while our trained chauffeurs drive you safely on your outstation journeys. Our chauffeur-driven Innova Crysta services from Pune combine safety, local route expertise, and professional service to make your trip smooth and worry-free."
    },
    {
      "name": "Budget Innova Crysta Outstation Pune",
      "description": "Looking for an affordable yet premium travel option? Our budget Innova Crysta outstation rentals from Pune provide luxury at a fair price, with no hidden charges and packages that suit both short and long-distance travel plans."
    },
    {
      "name": "Family Innova Crysta Outstation Pune",
      "description": "Travel with your loved ones in comfort with our family-friendly Innova Crysta outstation cab service from Pune. With spacious 6/7-seater options, AC, reclining seats, and plenty of luggage room, it’s ideal for family road trips or vacations."
    },
    {
      "name": "Online Innova Crysta Outstation Booking Pune",
      "description": "Book your outstation Innova Crysta online from Pune in just a few clicks. Our seamless digital booking platform offers instant confirmation, transparent pricing, and multiple payment options for a hassle-free reservation experience."
    }
  ],
  "tableData": [
    ["Pune to Outstation Innova Crysta Cab Booking", "Rent Innova Crysta for Outstation Pune"],
    ["One Way Innova Crysta Pune Outstation", "Round Trip Innova Crysta Outstation Pune"],
    ["Chauffeur Driven Innova Crysta Outstation Pune", "Budget Innova Crysta Outstation Pune"],
    ["Family Innova Crysta Outstation Pune", "Online Innova Crysta Outstation Booking Pune"]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Book Innova Crysta for Outstation Travel from Pune",
        "WhyChoosedescription": "Plan your outstation trips with ease by booking our premium Innova Crysta cabs from Pune. Whether you’re traveling to hill stations, religious destinations, or coastal towns, our service ensures you enjoy a smooth, safe, and comfortable journey."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable for Long-Distance Rides",
        "WhyChoosedescription": "With seating for 6–7 passengers, extra legroom, rear AC vents, and a large luggage compartment, Innova Crysta is designed to deliver superior comfort on long routes—making it ideal for families, corporate teams, or groups of friends."
    },
    {
        "WhyChooseheading": "Expert Chauffeurs for Intercity Routes",
        "WhyChoosedescription": "Our professional drivers are experienced in long-distance travel and familiar with all major routes from Pune including Mumbai, Shirdi, Goa, Mahabaleshwar, Lonavala, and more. They prioritize your safety, punctuality, and convenience at every step."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "Every Innova Crysta is thoroughly cleaned and disinfected before each trip. We ensure all vehicles are regularly serviced and kept in top mechanical condition to provide a safe and worry-free ride."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Itineraries",
        "WhyChoosedescription": "Choose from one-way or round-trip bookings, plan multiple-day tours, or request custom pickup/drop-off points and travel schedules. We adjust to your travel preferences for maximum flexibility."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Our outstation cab fares include driver charges, tolls, taxes, and fuel with no hidden fees. Enjoy premium service with complete clarity and honest pricing—ideal for both personal and business travel."
    },
    {
        "WhyChooseheading": "Ideal for Holidays, Pilgrimages, and Corporate Travel",
        "WhyChoosedescription": "Innova Crysta cabs are perfect for weekend getaways, extended vacations, spiritual journeys, and executive travel. Enjoy a premium ride experience no matter the purpose of your trip."
    },
    {
        "WhyChooseheading": "24/7 Booking and Travel Support",
        "WhyChoosedescription": "Book anytime online or through our helpline. Our customer support team is available round the clock to assist with bookings, travel updates, itinerary changes, and special requests."
    }
]




















    }

const faqData = [
    {
        question: "How do I book an Innova Crysta for outstation trips from Pune?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or via our website for quick and easy booking."
    },
    {
        question: "Which outstation destinations are covered from Pune?",
        answer: "We cover popular destinations such as Mumbai, Goa, Hyderabad, Aurangabad, Mahabaleshwar, Shirdi, Panchgani, and more."
    },
    {
        question: "Is the Innova Crysta comfortable for long outstation journeys?",
        answer: "Yes, the Innova Crysta offers ample space and a smooth ride, ideal for long-distance travel."
    },
    {
        question: "Can I book a one-way or round trip for outstation travel?",
        answer: "Yes, both one-way and round-trip bookings are available according to your travel plans."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Are the vehicles sanitized before each trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every journey for passenger safety."
    },
    {
        question: "Do your drivers have experience with outstation routes?",
        answer: "Absolutely. Our drivers are skilled and familiar with outstation routes to ensure a safe journey."
    },
    {
        question: "What is included in the rental fare for outstation Innova Crysta?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting time or parking fees may apply."
    },
    {
        question: "Is the outstation Innova Crysta service available 24/7?",
        answer: "Yes, Meghana Cab provides round-the-clock service for outstation bookings."
    },
    {
        question: "What payment methods are accepted for booking?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for an outstation trip from Pune. The car was spacious and the driver very professional.”',
    },
    {
        name: 'Ms. Shweta Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service and smooth ride for our Pune to Goa trip. Highly recommend Meghana Cab!”',
    },
];




















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const puneToOutstationInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Outstation Innova Crysta Cab Booking",
  "description": "Rent chauffeur-driven Innova Crysta cabs for outstation trips from Pune. Available for one way, round trips, family travel, and budget-friendly rides with online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-outstation-innova-crysta-booking"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Outstation Innova Crysta Cab Booking | Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs for outstation trips from Pune. One way and round trip options available. Affordable and reliable service."
  />
  <meta
    name="keywords"
    content="Pune to Outstation Innova Crysta Cab Booking, Rent Innova Crysta for Outstation Pune, One Way Innova Crysta Pune Outstation, Round Trip Innova Crysta Outstation Pune, Chauffeur Driven Innova Crysta Outstation Pune, Budget Innova Crysta Outstation Pune, Family Innova Crysta Outstation Pune, Online Innova Crysta Outstation Booking Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToOutstationInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetooutstationinnovacrysta;